module.exports = __webpack_public_path__ + "img/waiter-j.4ba42513.svg";